import { useCallback, useEffect, useState } from "react";
import authTenantApis from "src/api/authTenant";
import { PlanUsageResponse } from "src/types/planUsage.types";

const usePlanUsage = (options?: { enabled?: boolean }) => {
  const enabled = options?.enabled ?? true;
  const [planUsage, setPlanUsage] = useState<PlanUsageResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const loadPlanUsage = useCallback(async () => {
    setLoading(true);
    try {
      const response = (await authTenantApis.getPlanUsage()) as PlanUsageResponse;
      setPlanUsage(response);
    } catch (error) {
      console.error("Failed to load plan usage", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    loadPlanUsage();
  }, [enabled, loadPlanUsage]);

  return { planUsage, loading, refresh: loadPlanUsage };
};

export default usePlanUsage;
